'use client';
import { PAGE_QUERY_RESULT } from '@/sanity.types';
import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import './accordian.scss';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import { PortableTextBlock } from 'next-sanity';

type AccordionProps = Extract<
  NonNullable<NonNullable<PAGE_QUERY_RESULT>['content']>[number],
  { _type: 'faqLandingPage' }
>;
type itemType = AccordionProps['items'];

type AccordionComponentProps = {
  items: itemType;
};
export const AccordianComponent = ({ items }: AccordionComponentProps) => {
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const handleToggle = (key: string) => {
    setActiveKey(activeKey === key ? null : key);
  };
  return (
    <div className="faqAccordian">
      <Accordion activeKey={activeKey}>
        {items?.map((item, index) => (
          <Accordion.Item
            eventKey={index.toString()}
            className={activeKey === index.toString() ? 'show-item' : ''}
            onClick={() => handleToggle(index.toString())}
            key={index}
          >
            <Accordion.Header>{item?.question}</Accordion.Header>
            <Accordion.Body>
              <LandingPortableText
                value={item?.answer as PortableTextBlock[]}
              />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};
